<template>
  <div>
    <van-row id="appContent">
      <van-row :style="'background-image: url('+themeAsset('mobile/images/jobfair_net/php.png')+');'" class="beijing">
        <div class="nav"></div>
        <div class="head" v-if="jobfairInfo.jobfair">
          <div class="title">{{ jobfairInfo.jobfair.title }}</div>
          <div class="data">
            <div>时间：{{ date_start }}-{{ date_end }}</div>
            <div class="phone">咨询电话：{{ jobfairInfo.jobfair.phone }}</div>
            <div class="organizer" v-show="jobfairInfo.jobfair.auspices">
              主办单位：{{ jobfairInfo.jobfair.auspices }}
            </div>
            <div class="organizer" v-show="jobfairInfo.jobfair.undertake">
              承办单位：{{ jobfairInfo.jobfair.undertake }}
            </div>
            <div class="organizer" v-show="jobfairInfo.jobfair.assist">协办单位：{{
                jobfairInfo.jobfair.assist
              }}
            </div>
          </div>
        </div>
      </van-row>
      <van-row class="search">
        <div class="jobfair">
          <div class="join_jobfair">
            <div class="join_left">
              <img :src="themeAsset('mobile/images/jobfair_net/1.png')">
            </div>
            <div class="join_right">
              <div>参会企业</div>
              <div v-if="jobfairInfo.jobfairComCount">{{ jobfairInfo.jobfairComCount }}</div>
              <div v-else>0</div>
            </div>
          </div>
          <div class="join_jobfair">
            <div class="join_left">
              <img :src="themeAsset('mobile/images/jobfair_net/2.png')">
            </div>
            <div class="join_right">
              <div>参会职位</div>
              <div v-if="jobfairInfo.putJobCount">{{ jobfairInfo.putJobCount }}</div>
              <div v-else>0</div>
            </div>
          </div>
          <div class="join_jobfair">
            <div class="join_left">
              <img :src="themeAsset('mobile/images/jobfair_net/3.png')">
            </div>
            <div class="join_right">
              <div>参会求职者</div>
              <div v-if="jobfairInfo.perCount">{{ jobfairInfo.perCount }}</div>
              <div v-else>0</div>
            </div>
          </div>
        </div>
      </van-row>
      <div style="width: 100%;height: 0.3rem;background-color: #F8F8FA;" v-if="jobfairInfo.jobfair.status===1"></div>
      <van-row v-else>
        <div class="join_company">
          <div>招聘会简介</div>
          <div class="line"></div>
        </div>
        <div class="inform" style="overflow:hidden;">
          <section v-html="jobfairInfo.jobfair.jobfair_introduction"></section>
        </div>
      </van-row>
      <div class="join_company" v-if="userInfo.login_type===1">
        <div>入场求职者</div>
        <div class="line"></div>
      </div>
      <van-list
          finished-text="没有更多了"
          v-if="userInfo.login_type===1"
      >
        <div v-for="(item,index) in jobfairInfo.perList" :key="index" class="person-item">
          <div class="company">
            <div class="company_left" @click="$window.location.href = item.mobile_url">
              <img :src="companyLogo(item.image)">
            </div>
            <div class="company_right" style="width: 100%">
              <div class="company_one" style="width: 100%">
                <div class="company_name" @click="$window.location.href = item.mobile_url" style="margin-top: 10px">
                  {{ item.resumes.fullname }} ({{ item.resumes.sex_cn }},{{ item.age }} 岁)
                  <br/>
                  <span style="color: rgba(28,28,28,0.4);font-size: 10px"
                        v-if="item.resumes.experience_cn && item.resumes.education_cn">
                                    {{ item.resumes.experience_cn }} | {{ item.resumes.education_cn }}学历
                                </span>
                  <span style="color: rgba(28,28,28,0.4);font-size: 10px"
                        v-else-if="item.resumes.experience_cn && !item.resumes.education_cn">
                                    {{ item.resumes.experience_cn }}
                                </span>
                  <span style="color: rgba(28,28,28,0.4);font-size: 10px"
                        v-else-if="!item.resumes.experience_cn && item.resumes.education_cn">
                                    {{ item.resumes.education_cn }}学历
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="recruit" style="padding-bottom: 0.15rem;">
            <div class="recruit_left" style="color: #ff9e40;">
              {{ item.resumes.intention_jobs }}
            </div>
            <div class="detail_job" style="width: 130px" v-if="item.online==1" @click="personChat(item.uid)">
              <div class="detail_right" style="float:right;">
                <img :src="themeAsset('mobile/images/jobfair_net/未标题-1.png')">
                <div>立即洽谈</div>
              </div>
            </div>
            <div class="detail_job" style="width: 130px" v-if="item.online==0" @click="personOfflineMes(item.uid)">
              <div class="detail_right" style="float:right;">
                <img :src="themeAsset('mobile/images/jobfair_net/未标题-1.png')">
                <div>我要留言</div>
              </div>
            </div>
          </div>

          <div class="fenge"></div>

          <div class="online_img" v-if="jobfairInfo.jobfair.status===1 && item.online===1">
            <img style="width: 0.49rem;height: 0.52rem;" :src="themeAsset('mobile/images/jobfair_net/7.png')">
          </div>
          <div class="online_img" v-else-if="jobfairInfo.jobfair.status===1 && item.online===0">
            <img style="width: 0.49rem;height: 0.52rem;" :src="themeAsset('mobile/images/jobfair_net/离线.png')">
          </div>
          <div class="online_img" v-else></div>
        </div>
      </van-list>

      <div class="join_company" v-if="userInfo.login_type!==1">
        <div>参展企业</div>
        <div class="line"></div>
      </div>
      <van-list
          finished-text="没有更多了"
          v-if="userInfo.login_type!==1"
      >
        <div v-for="(item,index) in jobfairInfo.jobfairCom" :key="index" class="detail">
          <div class="company">
            <div class="company_left"><img :src="companyLogo(item.companys.logo)"></div>
            <div class="company_right">
              <div class="company_one">
                <div class="index" :style="'background-image: url('+themeAsset('mobile/images/jobfair_net/6.png')+');'">
                  {{ item.position }}
                </div>
                <div class="company_name van-ellipsis" @click='$window.location.href=item.mobile_url'>{{
                    item.companys.companyname
                  }}
                </div>
                <img v-if="item.recommend === 2" :src="themeAsset('mobile/images/jobfair_net/5.png')">
              </div>
              <div class="company_two" v-if="jobfairInfo.jobfair.status===1">
<!--                <div class="company_chat">-->
<!--                  <div>{{ item.exTalkNun }}</div>-->
<!--                  <div>人洽谈中</div>-->
<!--                </div>-->
<!--                <div class="company_wait">-->
<!--                  <div>{{ item.waitNum }}</div>-->
<!--                  <div>人等待洽谈</div>-->
<!--                </div>-->
              </div>
            </div>
          </div>

          <div class="recruit" style="padding-bottom: 0.15rem;"
               :style="active === index ? 'border-bottom: 1px dashed #e8e8e8' : 'border-bottom:none'">
            <div class="recruit_left">
              <div class="recruit_job">
                <div>共<span>{{ item.jobs_audit.length }}</span>个在招岗位</div>
              </div>
              <div class="shu">｜</div>
              <div class="recruit_number">
                <div>共<span>{{ item.amount }}</span>个招聘人数</div>
              </div>
            </div>
            <img :src="themeAsset('mobile/images/jobfair_net/19.png')" @click="clickshowit(index)"
                 :style="active === index ? 'transform: rotate(0deg)' : 'transform: rotate(180deg)'">
          </div>

          <div v-show="showitarr.indexOf(index)>=0">
            <div class="detail_job" v-for="(value,key) in item.jobs_audit" :key="key">
              <div class="detail_left">
                <img :src="themeAsset('mobile/images/jobfair_net/dian.png')" style="width: 0.2rem;height: 0.2rem;">
                <div class="job_name" @click="$window.location.href = value.mobile_url">{{ value.jobs_name }}</div>
              </div>
              <div class="detail_zhong">
                <div class="wage">{{ value.wage_cn }}</div>
              </div>
              <div class="recruit">
                <div class="handle_group">
                  <div class="delivery_btn font10" style="background-color: #a9a9a9" v-if="jobfairInfo.jobfair.status!=1">投递
                  </div>
                  <div class="delivery_btn font10" v-else @click="deliverResume(item.companys.id,value.id)">投递</div>
                  <div class="chat_btn font10" @click="companyChat(value.id)"  v-if="jobfairInfo.jobfair.status==1 && item.online==1">洽谈
                  </div>
                  <div class="chat_btn font10" style="background-color: #999999;" v-else  @click="companyOfflineMes(item.company_id)">留言
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="fenge"></div>

          <div class="online" v-if="jobfairInfo.jobfair.status==1 && item.online==1">
            <img :src="themeAsset('mobile/images/jobfair_net/7.png')">
          </div>
          <div class="online" v-else-if="jobfairInfo.jobfair.status==1 && item.online==0">
            <img :src="themeAsset('mobile/images/jobfair_net/离线.png')">
          </div>
          <div class="online" v-else></div>

        </div>
      </van-list>

      <div class="load_more_footer"></div>

      <!-- 定位按钮 myChat 就是洽谈个数-->
      <router-link to="/chat">
        <div class="position" :class="totalUnreadCount>=1?'flicker':''">
          <img :src="themeAsset('mobile/images/jobfair_net/绿喇叭.png')">
          <div class="shuzi" v-if="totalUnreadCount>=1">{{ totalUnreadCount }}</div>
        </div>
      </router-link>

      <div style="height: 1.28rem;"></div>


      <div class="back-to-top" v-if="backTop" id="back-to-top" @click="scrollPageTop"
           :style="'background: url('+themeAsset('mobile/images/235.png')+')  no-repeat;background-size: .8rem;'"></div>

      <van-action-sheet v-model="showOfflineMes"
                        title="发送留言"
                        cancel-text="取消">
        <div class="content">
          <van-field v-model="valueOfflineMes" placeholder="请输入留言内容"/>
          <van-button type="default" @click="onOfflineMes" block>发送</van-button>
        </div>
      </van-action-sheet>
      <van-action-sheet
          v-model="selectJobShow"
          :actions="imUserInfo.jobs_list_m"
          cancel-text="取消"
          description="选择沟通的职位"
          close-on-click-action
          @select="handleSelectJobClick"
      />
      <van-action-sheet
          v-model="selectResumeShow"
          :actions="imUserInfo.resume_list_m"
          cancel-text="取消"
          description="选择发送的简历"
          close-on-click-action
          @select="handleSelectResumeClick"
      />
    </van-row>
  </div>
</template>

<script>
import { mapGetters, mapState} from 'vuex'
import { isEmpty, theme_asset} from '@/utils/common'
import {getDate, getTime, isToday} from '@/utils/date'

export default {
  name: 'HomeView',
  data() {
    return {
      active: -1,
      showitarr: [],
      backTop: false,
      showOfflineMes: false,
      valueOfflineMes: '',
      uidOfflineMes: null,
      selectJobShow: false,
      selectJobToUserId: null,
      selectResumeToUserId: null,
      selectResumeToJobId: null,
      selectResumeShow: false,
    }
  },
  computed: {
    ...mapState('common', ['jobfairInfo','userInfo', 'imUserInfo']),
    ...mapGetters('conversation', ['totalUnreadCount']),
    date_start() {
      if (!this.jobfairInfo.jobfair.holddate_start) {
        return ''
      }
      const date = new Date(this.jobfairInfo.jobfair.holddate_start * 1000)
      if (isToday(date)) {
        return getTime(date)
      }
      return getDate(date)
    },
    date_end() {
      if (!this.jobfairInfo.jobfair.holddate_end) {
        return ''
      }
      const date = new Date(this.jobfairInfo.jobfair.holddate_end * 1000)
      if (isToday(date)) {
        return getTime(date)
      }
      return getDate(date)
    },
  },
  created() {

  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    themeAsset(path) {
      return theme_asset(path)
    },
    clickshowit(index) {
      let slot = this.showitarr.indexOf(index)
      if (slot < 0) {
        this.showitarr.push(index)
      } else {
        this.showitarr.splice(slot, 1)
      }
      this.active = this.active === index ? -1 : index
    },
    //企业logo
    companyLogo(data) {
      if (isEmpty(data)) {
        return process.env.VUE_APP_URL + '/data/upload/no_logo.png'
      } else {
        return data
      }
    },
    //页面滚动
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(scrollTop);
      this.backTop = scrollTop > 120;
    },
    //页面返回顶部
    scrollPageTop() {
      let timer = setInterval(function () {
        //获取滚动条到顶部的位置
        let osTop = document.documentElement.scrollTop || document.body.scrollTop
        let ispeed = Math.floor(-osTop / 5)
        // 判断到顶部的等式：滚动条到顶部的位置 + 当前窗口内容可视区 == 滚动条的总高度
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
        //this.isTop = true
        if (osTop === 0) {
          clearInterval(timer)
        }
      }, 30)
    },
    /**
     * 企业点击个人的立即洽谈
     */
    async personChat(uid) {
      if (this.userInfo.login_type === 0) {
        this.$toast('请先登录')
        return;
      }
      if (this.userInfo.login_type !== 1) {
        this.$toast('请登录企业账号');
        return;
      }
      if (this.imUserInfo.jobs_list_m.length < 1) {
        this.$toast('您没有职位或者职位未审核通过');
        return;
      }
      if (this.imUserInfo.jobs_list_m.length > 1) {
        this.selectJobToUserId = uid;
        this.selectJobShow = true;
        return;
      }
      const res = await this.$store.dispatch(
          'company/netTalkCompany',
          {
            jobId: this.imUserInfo.jobs_list_m[0].value,
            toUserId: uid,
            jobfair_id: this.$jobfairId
          },
      )
      if (!res.data.accid){
        this.$toast('创建洽谈异常')
        return
      }
      this.gotoChatPage(res.data.accid);
    },
    /**
     * 个人点击企业的立即洽谈
     */
    async companyChat(jobId) {
      if (this.userInfo.login_type === 0) {
        this.$toast('请先登录')
        return;
      }
      if (this.userInfo.login_type !== 2) {
        this.$toast('请登录个人账号');
        return;
      }
      if (this.imUserInfo.resume_list_m.length < 1) {
        this.$toast('您没有简历或者简历未审核通过');
        return;
      }
      const res = await this.$store.dispatch(
          'person/netTalkPerson',
          {
            jobId: jobId,
            jobfair_id: this.$jobfairId
          },
      )
      if (res.status === 200) {
        if (res.message !== 'ok') {
          this.$toast(res.message)
        }
        if (!res.data.accid){
          this.$toast('创建洽谈异常')
          return
        }

        this.gotoChatPage(res.data.accid);
      } else {
        this.$toast(res.message)
      }

    },
    handleSelectJobClick(item) {
      let that = this;
      if (isEmpty(item.value)) {
        that.$toast('请先选择要发送的职位')
        return
      }
      that.$store.dispatch(
          'company/netTalkCompany',
          {
            jobId: item.value,
            toUserId: that.selectJobToUserId
          },
      ).then(function (res) {
        if (res.status === 200) {
          if (res.message !== 'ok') {
            that.$toast(res.message)
          }
          that.gotoChatPage(res.data.accid);
        } else {
          that.$toast(res.message)
        }
      })
    },
    gotoChatPage(toUser) {
      this.$router.push({name: 'chats', query: {userId: toUser}})
    },
    /**
     * 企业点击个人的我要留言
     * @param uid
     */
    personOfflineMes(uid) {
      if (this.userInfo.login_type === 0) {
        this.$toast('请先登录')
        return;
      }
      if (this.userInfo.login_type !== 1) {
        this.$toast('请登录企业账号');
        return;
      }
      this.uidOfflineMes = uid;
      this.showOfflineMes = true;
      this.valueOfflineMes = '';
    },
    /**
     * 个人点击企业的我要留言
     * @param uid
     */
    companyOfflineMes(uid) {
      if (this.userInfo.login_type === 0) {
        this.$toast('请先登录')
        return;
      }
      if (this.userInfo.login_type !== 2) {
        this.$toast('请登录个人账号');
        return;
      }
      this.uidOfflineMes = uid;
      this.showOfflineMes = true;
      this.valueOfflineMes = '';
    },
    /**
     * 输入内容后点击发送
     */
    onOfflineMes() {
      if (isEmpty(this.valueOfflineMes)) {
        this.$toast('请输入要留言内容');
      }
      this.$store.dispatch('common/sendOfflineMes', {
        jobfair_id: this.$jobfairId,
        userId: this.userInfo.id,
        toUserId: this.uidOfflineMes,
        userType: this.userInfo.login_type,
        msg: this.valueOfflineMes
      })
      this.showOfflineMes = false;
    },
    /**
     * 个人投递简历
     * @param company_id
     * @param job_id
     */
    deliverResume(company_id, job_id) {
      if (this.userInfo.login_type === 0) {
        this.$toast('请先登录')
        return;
      }
      if (this.userInfo.login_type !== 2) {
        this.$toast('请登录个人账号');
        return;
      }
      if (this.imUserInfo.resume_list_m.length < 1) {
        this.$toast('您没有简历或者简历未审核通过');
        return;
      }
      if (this.imUserInfo.resume_list_m.length >= 1) {
        this.selectResumeToUserId = company_id;
        this.selectResumeToJobId = job_id;
        this.selectResumeShow = true;
        return;
      }
    },
    handleSelectResumeClick(item) {
      let that = this;
      let is_temp = 0;
      if(this.jobfairInfo.jobfair.is_temp){
        is_temp = this.jobfairInfo.jobfair.is_temp
        this.is_temp = is_temp
      }
      if (isEmpty(item.value)) {
        that.$toast('请先选择要发送的简历')
        return
      }
      //投递简历
      that.$store.dispatch(
          'person/applyResume',
          {
            jobId: that.selectResumeToJobId,
            resumeId: item.value,
            is_temp:is_temp
          },
      )
    }
  },
}
</script>

<style lang="less" scoped>

</style>
